import { Field } from 'formik';
import { Box } from '@chakra-ui/react';
import ElementInstructions from '../components/ElementInstructions';
import ElementHeading from '../components/ElementHeading';
import ElementErrorMessage from '../components/ElementErrorMessage';
import SelectBox from './components/SelectBox';
import { getUsefulVars } from '../../handlers/helpers';

const ComputerSkills = ({qObj, fieldName, props}) => {
  const style = props.stateProps.expertiseStyles;
  const uv = getUsefulVars(props);
  if(uv.resume.computerData !== undefined) {
    qObj.options = uv.resume.computerData.options;
  } else {
    qObj.options = [];
  }

  return (
    <Field name={fieldName}>
      {({ field, form }) => {
        let val = field.value;
        return (
          <>
            <ElementHeading qObj={qObj} props={props} />
            <ElementInstructions instructions={qObj.instructions} />
            <Box sx={{ ...style.phone.margins }}>
              <Box>
                <SelectBox props={props} qObj={qObj} val={val} style={style} />
              </Box>
            </Box>
            <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
          </>
        );
      }}
    </Field>
  );
};
export default ComputerSkills;
